import { Alert } from '@ahmdigital/ui';
import styled from 'styled-components';

import * as constants from '../../../models/url/constants';
import hasLandingPage from '../utils/has-landing-page';
import LoadingSpinner from '../../../components/loading-spinner';
import PerksDetailContent from './components/content';
import RedirectAdapter from '../../../utils/redirect-adapter';
import useGetPerk from './utils/use-get-perk';
import WrapperComponent from './components/wrapper';

type PerksDetailPageProps = {
  location?: {
    query: {
      m: string;
    };
  };
  match: {
    params: {
      slug: string;
    };
  };
};

const ErrorAlert = styled(Alert)`
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

const PerksDetailPage = ({ location, match }: PerksDetailPageProps) => {
  const slug = match?.params?.slug;
  const queryMagicLinkCode = location?.query?.m;
  const { error, loading, perk } = useGetPerk(slug);

  if (loading) {
    return (
      <WrapperComponent>
        <LoadingSpinner />
      </WrapperComponent>
    );
  }
  if (error) {
    return (
      <WrapperComponent>
        <ErrorAlert
          analyticsLabel="Perks details GraphQL call failed"
          heading="Oops! Something went wrong"
          level="danger"
        >
          Looks like we’re having a bit of trouble getting the perk for you. Take a break and try again later.
        </ErrorAlert>
      </WrapperComponent>
    );
  }
  if (perk && hasLandingPage(perk)) {
    return <PerksDetailContent {...{ error, loading, perk, queryMagicLinkCode }} />;
  }
  return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
};

export default PerksDetailPage;
